export default __webpack_public_path__ + "static/media/instagram-hover.5ba46504.svg";